import { render } from "./TariffProviderComponent.vue?vue&type=template&id=3fa7420c&scoped=true"
import script from "./TariffProviderComponent.vue?vue&type=script&lang=js"
export * from "./TariffProviderComponent.vue?vue&type=script&lang=js"

import "./TariffProviderComponent.vue?vue&type=style&index=0&id=3fa7420c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fa7420c"]])

export default __exports__